<template>
  <ica-modal
    v-model="active"
    title="Olika inställningar av cookies"
    tracking-name="Olika inställningar av cookies"
    :z-index="200"
  >
    <template #content>
      <h3 class="consent-diff-modal__header">
        Vilka inställningar vill du använda?
      </h3>
      <p class="consent-diff-modal__p">
        Dina inställningar av cookies på ICA skiljer sig från de du har i din
        webbläsare. Välj vilka inställningar du vill ha på ICA.
      </p>
      <button
        type="button"
        class="cdm-button--40 consent-diff-modal__profile"
        @click="setConsentProfile('cloud')"
      >
        Fortsätt använda dina ICA-inställningar
      </button>
      <button
        type="button"
        class="cdm-button--40 cdm-button--secondary consent-diff-modal__browser"
        @click="setConsentProfile('browser')"
      >
        Använd webbläsarens inställningar
      </button>
    </template>
    >
  </ica-modal>
</template>

<script>
import IcaModal from "./Modal"
// import OneTrustProfileSynchronizer from '../../syncflow/OT/OneTrustProfileSynchronizer'

export default {
  name: "IcaConsentDiffModal",
  components: {
    IcaModal,
  },
  data() {
    return {
      active: false,
    }
  },
  methods: {
    setConsentProfile(profileType) {
      try {
        window.OneTrustProfileSynchronizer.overwriteProfile(profileType)
      } catch (err) {
        console.error(err)
      }
      this.active = false
    },
  },
  mounted() {
    const self = this
    window.ICAConsentSDK = window.ICAConsentSDK || {};
    (window.ICAConsentSDK.openConsentDiffModal = function () {
      self.active = true
    }),
      (window.ICAConsentSDK.closeConsentDiffModal = function () {
        self.active = true
      })
  },
}
</script>

<style lang="scss" scoped>
$icaAtomsFontPath: "node_modules/@ica/ica-atoms/fonts";

@import "node_modules/@ica/ica-atoms/fonts/_baseTypography";
@import "node_modules/@ica/ica-atoms/variables/colors";

.cdm-button {
  &--32 {
    font-size: 0.875rem;
    padding: 0.5rem 1rem 0.5rem 1rem;
  }

  &--40 {
    font-size: 1rem;
    padding: 0.75rem 1.5rem;
  }

  &--48 {
    font-size: 1rem;
    padding: 1rem 1.5rem;
  }

  &--secondary {
    background-color: $color-secondary-cta-bkg;
    color: $color-secondary-cta-text;
    fill: $color-secondary-cta-text;
  }
}

.cdm-button,
[class*="button--"] {
  font-family: "ICA Text", sans-serif;
  font-weight: bold;
  font-size: 0.75rem;
  line-height: 1;
  padding: 0.375rem 1rem;
  border-radius: 3.125rem;
  appearance: none;
  border: 0;
  background-color: $color-primary-cta;
  color: $color-white;
  fill: $color-white;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;

  &:hover {
    background-color: $color-pink-light;
    color: $color-white;
    fill: $color-white;
  }

  &.cdm-button--active,
  &:active {
    background-color: $color-red-dark;
    color: $color-white;
    fill: $color-white;
  }

  &.cdm-button--disabled,
  &:disabled {
    background-color: $color-grey-special;
    color: $color-inactive-text;
    fill: $color-inactive-text;
    pointer-events: none;
  }
}

.tabnav-active .cdm-button,
.tabnav-active [class*="button--"] {
  &:focus {
    background-color: $color-pink-light;
    color: $color-white;
    fill: $color-white;
  }
}

.consent-diff-modal {
  &__header {
    @include font(rubrik, 3, "normal");

    text-align: center;
    margin-bottom: 16px;
  }

  &__p {
    @include font(text, 3, "normal");

    text-align: center;
    margin-bottom: 32px;
  }

  &__profile {
    display: block;
    margin: 0 auto 16px;
    // width: 100%;
    // @media all and (min-width: 768px) {
    //   width: 60%;
    // }
  }

  &__browser {
    display: block;
    margin: 0 auto;
    // width: 100%;
    // @media all and (min-width: 768px) {
    //   width: 60%;
    // }
  }
}
</style>
